require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-aux-journalistes-0-6-1.json") })
        }
      }, "path---services-aux-journalistes-0-6-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-aux-journalistes-0-6-1!./.cache/json/services-aux-journalistes-0-6-1.json
// module id = 571
// module chunks = 231608221292675